import './theme/scripts/prognostics'
